import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosRestaurantInstance from './AxiosRestaurantInstance';
import FloatingLabelInput from './PlaceHolder';
import logo from './assets/junior-eats-logo.png';
import bike from './assets/bike.png';
import restaurant from './assets/Restaurant.png';
import children from './assets/children.png';

import './css/SignUp.css'; // This will now contain the shared Signin/Signup styles


const Signup = () => {
  const [step, setStep] = useState(1);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ''); // Allow only numbers
    const newOtp = [...otp];
  
    if (value === '') {
      // Clear current box and move to the previous box if backspace
      newOtp[index] = '';
      setOtp(newOtp);
  
      if (element.previousSibling) {
        element.previousSibling.focus();
      }
    } else if (value.length === 1) {
      // Update the current box
      newOtp[index] = value;
      setOtp(newOtp);
  
      // Move to the next box if available
      if (element.nextSibling) {
        element.nextSibling.focus();
      }
    } else {
      // If user pastes more than one character, ignore the input
      element.value = otp[index];
    }
  };
  
  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace' && !otp[index]) {
      // If the current box is empty and backspace is pressed, move to the previous box
      if (event.target.previousSibling) {
        event.target.previousSibling.focus();
      }
    }
  };

  const requestOtp = async (purpose) => {
    try {
      const response = await axiosRestaurantInstance.post('/request', { 
        identifier: email, 
        purpose: "signup"
      });
  
      alert(response.data.message);
      setStep(2);
    } catch (error) {
      console.error('Request OTP Error:', error.response || error);
      alert(error.response?.data?.message || 'An error occurred');
    }
  };

  const verifyOtp = async () => {
    try {
      const otpString = otp.join('');
      await axiosRestaurantInstance.post('/verify', { identifier: email, otp: otpString });
      // alert('OTP verified');
      registerUser();
    } catch (error) {
      alert(error.response?.data?.message || 'Invalid OTP');
    }
  };
  

  const registerUser = async () => {
    if (password !== confirmPassword) {
      alert("Passwords don't match!");
      return;
    }

    try {
      await axiosRestaurantInstance.post('/root-admin', {
        firstName: firstName,
        lastName: lastName,
        mobile,
        email,
        password,
        
      });

      // alert('Registration successful');
      navigate('/restaurant/signin');
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to register');
    }
  };

  // Step 1: User details form
  const renderStep1 = () => (
    <div className="signup_form">
    <h3 className='signup_heading' style={{marginTop:'15px'}}>Restaurant</h3>
      <FloatingLabelInput
  type="text"
  value={firstName}
  onChange={(e) => setFirstName(e.target.value)}
  label="First Name"
  isRequired={true}
/>
<FloatingLabelInput
  type="text"
  value={lastName}
  onChange={(e) => setLastName(e.target.value)}
  label="Last Name"
  isRequired={true}
/>
<FloatingLabelInput
  type="text"
  value={mobile}
  onChange={(e) => setMobile(e.target.value)}
  label="Mobile Number"
  isRequired={true}
/>
<FloatingLabelInput
  type="email"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  label="Email"
  isRequired={true}
/>
<FloatingLabelInput
  type="password"
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  label="Password"
  isRequired={true}
/>
<FloatingLabelInput
  type="password"
  value={confirmPassword}
  onChange={(e) => setConfirmPassword(e.target.value)}
  label="Confirm Password"
  isRequired={true}
/>
      <button className="signup_button" onClick={requestOtp}>
        Sign Up
      </button>
      <div className="signup_signup" style={{marginLeft:'5px'}}>
       <span> Already have an account?</span> <a href="/restaurant/signin" className="signup_link"  style={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#007bff',
                textAlign: 'center',
                textDecoration: 'none',
                marginLeft:'15px'
            }}>Sign In</a><a href="https://jreats.com/" className="signup_link" style={{marginLeft:'15px'}}>Home</a>
      </div>
    </div>
  );

  // Step 2: OTP verification form
  const renderStep2 = () => (
    <div className="signup-otp-form-container">
      <p className="signup-otp-instruction">Enter the OTP sent to your email</p>
  
      {/* OTP Input Boxes */}
      <div className="signup-otp-box-container">
        {otp.map((value, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            className="signup-otp-box"
            value={value}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleKeyDown(e, index)} // New handler for backspace
            onFocus={(e) => e.target.select()} // Automatically selects the box content
          />
        ))}
      </div>
  
      <button className="signup-otp-verify-button" onClick={verifyOtp}>
        Verify OTP
      </button>
  
      <p className="signup-otp-resend-text">
        Didn’t receive the OTP?{" "}
        <button type="button" className="signup-otp-resend-link" onClick={requestOtp}>
          Resend OTP
        </button>
      </p>
    </div>
  );
  

  return (
    <div className="signup_container">
      <div className="signup_leftSection">
        {/* Optional images for visuals */}
        <img src={children} alt="Children" className="signup_children" />
        <img
         src={restaurant} 
         alt="Restaurant" 
         className="signup_restaurant" 
         />
        
        <img src={bike} alt="Bike" className="signup_bike" />
      </div>
      <div className="signup_rightSection">
        <img src={logo} alt="Logo" className="signup_logo" />
        <div className="signup_content">
        {step === 1 && renderStep1()}
        {step === 2 && renderStep2()}
        </div>
      </div>
    </div>
  );
};

export default Signup;
